export function getAggregatorGroupType(type, timelineStep) {
    return timelineStep ? `${type}/${timelineStep}` : type;
}
